import * as actionTypes from "../actions";

const initialState = {
    isSummaryLoading: false,
    summary: null,
    summaryError: null,
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DASHBOARD_LOADING_SUMMARY: {
            return {
                ...state,
                isSummaryLoading: true,
                summaryError: null,
            };
        }
        case actionTypes.GET_CUSTOMER_DASHBOARD_SUMMARY: {
            return {
                ...state,
                isSummaryLoading: false,
                summary: action.payload || null,
                summaryError: null,
            };
        }
        case actionTypes.GET_CUSTOMER_DASHBOARD_SUMMARY_FAIL: {
            return {
                ...state,
                isSummaryLoading: false,
                summaryError: action.payload || null,
            };
        }
        default:
            return state;
    }
};

export default dashboardReducer;
